module.exports = __webpack_public_path__ + "img/06a-osm-emissao-nova.d4b66a47.png";